import { systemStatusTypes } from '@twiliointernal/e2-commons-shared-ui';
import { SupportSearchProps } from '../../supportSearch/definitions/types';
import { ReactElement, ReactNode } from 'react';

export interface LayoutProps {
  searchProps?: SupportSearchProps;
  outletOverride?: ReactElement;
}

export interface SidebarNavigationProps {
  children: ReactNode;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

export interface TopbarSupportPlanFeatures {
  web: boolean;
  phone: boolean;
}

export interface ErrorMenuProps {
  type: ErrorMenuType;
  redirectUrl: string;
}

export enum ErrorMenuType {
  supportPlan = 'supportPlan',
  systemStatus = 'systemStatus',
}

export type StatusByGroup = Record<
  systemStatusTypes.SystemStatusTypes,
  systemStatusTypes.SystemStatus[]
>;
